import Generic from './documents/Generic.vue';
import Product from './documents/Product.vue';
import Dealer from './documents/Dealer.vue';
export const MIN_INPUT_LENGTH = 2;
export const indexesCardComponents = {
    vtec_products: Product,
    vtec_articles: Generic,
    vtec_news: Generic,
    vtec_pages: Generic,
    vtec_dealers: Dealer,
};
function mixinDefaults(def = {}) {
    return structuredClone(Object.assign(Object.assign({}, def), { attributesToHighlight: ['title', 'excerpt'].concat(def.attributesToHighlight || []), highlightPreTag: '<mark>', highlightPostTag: '</mark>', 
        // TODO wait until the "first" matching strategy is available
        //  @link https://roadmap.meilisearch.com/c/62-policy-for-matching-words
        //matchingStrategy: 'last',
        matchingStrategy: 'all' }));
}
const indexDefs = {
    vtec_products: mixinDefaults({
        limit: 8,
        attributesToHighlight: [
            'product_categories.label',
            'application_areas.primary.label',
            'application_areas.secondary.label',
        ],
    }),
    vtec_news: mixinDefaults({
        limit: 3,
    }),
    vtec_articles: mixinDefaults({
        limit: 3,
    }),
    vtec_pages: mixinDefaults({
        limit: 3,
    }),
    vtec_dealers: mixinDefaults({
        limit: 3,
        attributesToHighlight: [
            'country',
            'department',
            'address',
        ],
    }),
};
export function getStandAloneSearchArgsDefaults(indexUid) {
    const stdArgs = indexDefs[indexUid];
    if (stdArgs) {
        const args = structuredClone(stdArgs);
        args.limit = 12;
        return args;
    }
    return {};
}
export function getMultiSearchArgsDefaults() {
    return structuredClone(indexDefs);
}
